import {
  QuestionnaireConditionService,
  RuleService,
  StatementService,
  OutcomeService,
  QuestionnaireLogicService,
  QuestionnairePathTraversal,
} from '@pollfish/pf-advanced-logic';
// } from '../../../pf-advanced-logic/pf-advanced-logic/dist'; // eslint-disable-line import/no-relative-packages

import {
  QLUnifyService,
  DefaultQlService,
} from '@pollfish/pf-library-of-power';
// } from '../../../pf-advanced-logic/pf-library-of-power/dist'; // eslint-disable-line import/no-relative-packages

const conditionService = new QuestionnaireConditionService();
const ruleService = new RuleService(conditionService);
const statementService = new StatementService(ruleService);
const outcomeService = new OutcomeService();
const questionnaireLogicService = new QuestionnaireLogicService(
  statementService,
  ruleService,
  outcomeService,
  conditionService,
);
const questionnairePathTraversal = new QuestionnairePathTraversal(
  questionnaireLogicService,
);
const qlUnifier = new QLUnifyService(questionnairePathTraversal);
const defaultQlService = new DefaultQlService(
  qlUnifier,
  questionnaireLogicService,
);

export {
  Matcher,
  QuestionnaireConditionContext,
  OutcomeType,
  Statement,
  Rule,
  Outcome,
  Operator,
  NextNode,
  NodeStatements,
  ConceptConditionContext,
  VALIDATION_ERRORS,
  VALIDATION_ERROR_LEVELS,
  VALIDATION_SCOPES,
  QuotaConditionContext,
  VariableConditionContext,
  OutcomeActionType,
  OutcomeGraphTypes,
  VisibilityContext,
  ActionVisibilityValueType,
  VirtualEntryGroupPostfix,
  FinalNode,
  FinalGroupNode,
  Questionnaire,
  isDefaultHideAnswerStatement,
  isDefaultHideNodeStatement,
  QuotaConditionTypeEnum,
  QuotaAssignmentStrategy,
  QuotaRuleFilter,
} from '@pollfish/pf-advanced-logic';
// } from '../../../pf-advanced-logic/pf-advanced-logic/dist'; // eslint-disable-line import/no-relative-packages

export {
  statementService,
  conditionService,
  ruleService,
  questionnaireLogicService,
  questionnairePathTraversal,
  qlUnifier,
  defaultQlService,
};
